import { GraphQLError } from 'graphql';
import { isAccessDeniedError } from './isAccessDeniedError';

export const shouldIgnoreErrors = (graphQLErrors: readonly GraphQLError[]) => graphQLErrors.some(isAccessDeniedError);
